__turbopack_context__.v({
  "className": "sxAKeq_className",
  "variable": "sxAKeq_variable",
});
